import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import MicroEvent from "../other/microevent";
import CommonHelper from "../helpers/CommonHelper";
import ifvisible from "ifvisible.js";
import Entrance from "./Entrance";
import Config from "../Config";
import {Globs, KEY} from "../Globs";
 
export default class Prices extends React.Component {

    constructor(props) {
        super(props);

        // MicroEvent.mixin(PanelPrice);

        this.state = {
            buy1m_disabled: true,
            buy2m_disabled: true,
            buy3m_disabled: true,
            buy6m_disabled: true,
        };

        this.handlePurchase1M = this.handlePurchase1M.bind(this);
        this.handlePurchase2M = this.handlePurchase2M.bind(this);
        this.handlePurchase3M = this.handlePurchase3M.bind(this);
        this.handlePurchase6M = this.handlePurchase6M.bind(this);
    }
  componentWillMount() {
    document.body.classList.add('prices-page');
  }

  componentWillUnmount(){
    document.body.classList.remove('prices-page');
      var id = (this.state.refInterval_forBuyButtonsUpdate);
      if(!CommonHelper.isNull(id)){
          clearInterval(id);
      }
  }

    componentDidMount() {
        this.updateBuyButtons();

        var refId = setInterval(() =>
            {
                this.updateBuyButtons();
            },
            10*1000);

        this.setState({refInterval_forBuyButtonsUpdate:refId});
    }

    updateBuyButtons(){

        if(!ifvisible.now()) { return ;}

        var zeroTimeleft = (Entrance.purchaseTimeLeft()<= 0);
        //console.log('zeroTimeleft'+zeroTimeleft);
        //var zeroTimeleft = (Entrance.purchaseTimeLeft()<= 0);
        this.setState({buy1m_disabled: !zeroTimeleft || CommonHelper.isNull(Entrance.purchaseEndTime())});
        this.setState({buy2m_disabled: !zeroTimeleft});
        this.setState({buy3m_disabled: !zeroTimeleft});
        this.setState({buy6m_disabled: !zeroTimeleft});
    }

    handlePurchase1M(){
        this.handlePurchase('1mn');
    }

    handlePurchase2M(){
        this.handlePurchase('2mn');
    }

    handlePurchase3M(){
        this.handlePurchase('3mn');
    }

    handlePurchase6M(){
        this.handlePurchase('6mn');
    }

    handlePurchase(nMonth){
        var w = window.open(Config.dirHostedAt+'/purchase/'+nMonth, '_self');
    }
  
  render() {
    return (
        <Container className="text-page price-page">
            <div className="panel-price">
                <Container>
                    <Row>
                        <Col xs="12" lg="4">
                            <div className="sc-box sc-box--alternate mbt-50">
                                <div className='sc-box-price-top-title'>1-month subscription</div>
                                <div className='sc-box-price-top-text'>1 month of activity on one account</div>
                                <div className='sc-box-price'>$9.99</div>
                                {/*<div className='sc-box-title'>1 month of activity on one account</div>*/}
                                <button id="green"
                                        className="sc-btn sc-btn-big sc-btn-border-red w-100 "
                                        disabled={Globs.get(KEY.BUSY) || this.state.buy1m_disabled}
                                        type='submit'
                                        onClick={this.handlePurchase1M}>Buy plan
                                </button>
                                <div className='sc-box-price-bottom-title'>No discount</div>
                                <div className='sc-box-price-bottom-text'>A month of subscription means 30 days from the moment right after the payment is accepted.</div>
                            </div>
                        </Col>
                        <Col xs="12" lg="4">
                            <div className="sc-box-price-bg-red">
                                <h1 className="sc-box-price-title-most-popular">MOST POPULAR</h1>
                            <div className="sc-box sc-box--alternate">
                                <div className='sc-box-price-top-title red' >3-month subscription</div>
                                <div className='sc-box-price-top-text f-11'>3 months of activity on one account
                                    {/*<span className="red">+ 15 days free</span>*/}
                                </div>
                                <div className='sc-box-price mb-120'>$26.99</div>
                                {/*<div className='sc-box-title'>3 months of activity on one account</div>*/}
                                <button id="green"
                                        className="sc-btn sc-btn-big sc-btn-border-red w-100 "
                                        disabled={Globs.get(KEY.BUSY) || this.state.buy1m_disabled}
                                        type='submit'
                                        onClick={this.handlePurchase3M}>Buy plan
                                </button>
                                <div className='sc-box-price-bottom-title'>5% discount</div>
                                <div className='sc-box-price-bottom-text'>Three month subscription is 90 days

                                    from the moment right after the payment is accepted.
                                </div>
                            </div>
                            </div>
                        </Col>
                        <Col xs="12" lg="4">
                            <div className="sc-box sc-box--alternate mbt-50">
                                <div className='sc-box-price-top-title'>6-month subscription</div>
                                <div className='sc-box-price-top-text'>6 months of activity on one account</div>
                                <div className='sc-box-price'>$53.99</div>
                                {/*<div className='sc-box-title'>6 months of activity on one account</div>*/}
                                <button id="green"
                                        className="sc-btn sc-btn-big sc-btn-border-red w-100"
                                        disabled={Globs.get(KEY.BUSY) || this.state.buy1m_disabled}
                                        type='submit'
                                        onClick={this.handlePurchase6M}>Buy plan
                                </button>
                                <div className='sc-box-price-bottom-title'>10% discount</div>
                                <div className='sc-box-price-bottom-text'>Six month subscription is 180 days from the moment right after the payment is accepted.
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/*<Row className="price-box">*/}
            {/*    <Col xs={12} lg={4}>*/}
            {/*        <div class="sc-box">*/}
            {/*            <div class="sc-box-title">700+ hours of growth</div>*/}
            {/*            <h1 class="sc-box-price">$9.99</h1>*/}
            {/*            <div class="sc-box-top">1 month of activity on one account</div>*/}
            {/*            <div class="sc-box-desc">*/}
            {/*                <p>No discount</p>*/}
            {/*                <p>A month of subscription means 30 days from the moment right after the payment is*/}
            {/*                    accepted.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </Col>*/}
            {/*    <Col xs={12} lg={4}>*/}
            {/*        <div class="sc-box sc-box--selected">*/}
            {/*            <div class="sc-box-title">1400+ hours of growth</div>*/}
            {/*            <h1 class="sc-box-price">$18.99</h1>*/}
            {/*            <div class="sc-box-top">2 months of activity on one account</div>*/}
            {/*            <div class="sc-box-desc">*/}
            {/*                <p><span className="text-red">5%</span> discount</p>*/}
            {/*                <p>A month of subscription means 30 days from the moment right after the payment is*/}
            {/*                    accepted.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </Col>*/}
            {/*    <Col xs={12} lg={4}>*/}
            {/*        <div class="sc-box">*/}
            {/*            <div class="sc-box-title">2000+ hours of growth</div>*/}
            {/*            <h1 class="sc-box-price">$26.99</h1>*/}
            {/*            <div class="sc-box-top">3 months of activity on one account</div>*/}
            {/*            <div class="sc-box-desc">*/}
            {/*                <p><span className="text-red">10%</span> discount</p>*/}
            {/*                <p>A month of subscription means 30 days from the moment right after the payment is*/}
            {/*                    accepted.</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row className="justify-content-md-center">
                <Col xs={12} md={8}>
                    <br/>
                    <p>By default, when you purchase a subscription, the recurring subscription payment is on.</p>
                    <p>You can turn your susbcription off at any time by going to “Profile” and turning off the AutoPay
                        switch.</p>
                    <p>For each adiitional linked account the price is the same. For users that have a lot of linked
                        accounts we can offer significant discounts on bulk purchases. Contact us with your
                        requirements.</p>
                    <p>With one month of activity an unestablished artist can get 200 followers each month. That means
                        that in three months you can gain 600 new organic followers, and assorted numerous plays, likes
                        etc.</p>
                </Col>
            </Row>
        </Container>
    )
  }
}
